import React from "react";
import ReactDOM from "react-dom/client";
// import 'react-quill/dist/quill.snow.css';
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import UserContextProvider from "./context/UserContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <UserContextProvider>
      <App/>
    </UserContextProvider>
  </>
);

reportWebVitals();
